// Returns a URL including the page number, given a base path.
// If your URL is `/`, pass an empty string.
// `page` is one-based

module.exports = function paginatedUrl(basePath, page) {
  if (page < 2) {
    return basePath || '/';
  }

  return `${basePath}/page/${page}`;
};
